import React from "react";
import HeaderTop from "../components/HeaderTop";
import RightSidebar from "../components/RightSidebar";
import LeftSidebar from "../components/LeftSidebar";
import Footer from "../components/Footer";
import CourseInfoCard from "../components/courses/CourseInfoCard";
import CourseDetailsContent from "../components/courses/CourseDetailsContent";

function CourseDetails() {
  return (
    <div id="main_content" className="font-muli theme-blush">
      <div className="page-loader-wrapper"><div className="loader"></div></div>

      <HeaderTop />
      <RightSidebar />
      <LeftSidebar />

      <div className="page">
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center">
              <div className="header-action">
                <h1 className="page-title">Course Details</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item"><a href="#">LMS</a></li>
                  <li className="breadcrumb-item"><a href="/courses">Courses</a></li>
                  <li className="breadcrumb-item active" aria-current="page">Details</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="row clearfix">
              {/* Left Column – Course Info */}
              <div className="col-lg-4 col-md-12">
                <CourseInfoCard />
              </div>

              {/* Right Column – Description, Syllabus */}
              <div className="col-lg-8 col-md-12">
                <CourseDetailsContent />
              </div>
            </div>
          </div>
        </div>

         
      </div>
    </div>
  );
}

export default CourseDetails;
